/* eslint-disable react-hooks/exhaustive-deps */
import { InputText } from "primereact/inputtext";
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { InputNumber } from "primereact/inputnumber";
import { DataTable, DataTableFilterMeta, DataTableSelectionSingleChangeEvent } from "primereact/datatable";
import { Column, ColumnEditorOptions } from "primereact/column";
import { useEffect, useMemo, useRef, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { Toast } from "primereact/toast";
import { classNames } from 'primereact/utils';
import { Panel } from "primereact/panel";
import { Button } from "primereact/button";
import React from "react";
import { Dialog } from "primereact/dialog";
import { Link } from "react-router-dom";
import { useMsal } from "@azure/msal-react";
import MaintenanceService from "../../service/MaintenanceService";
import SetupOptions from "../../models/SetupOptions";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { Dropdown } from "primereact/dropdown";
import { SetupOptionsService } from "../../service/SetupOptionsService";
import Fabric from "../../models/Fabric";
import Code from "../../models/Code";
import { Checkbox } from "primereact/checkbox";
import SetupOpt from "../../models/SetupOpt";
import autoTable from "jspdf-autotable";

interface DropdownItem {
    name: string;
    code: string;
}

const defaultFilters: DataTableFilterMeta = {
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    setupOptId: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    setupOptType: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    setupOptOpt: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    setupOptDesc: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    setupOptAs400: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    setupOptGroup: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    setupOptStatus: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    setupOptSeq: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    setupOptRgbRed: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    setupOptRgbGreen: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    setupOptRgbBlue: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    setupOptColor: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    setupOptFabric: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    setupOptComment: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    setupOptUpdUser: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    setupOptUpdTs: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    setupOptYthSize: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    }
};

export default function SetupOptView() {

    let empty: SetupOpt = {
        setupOptId: 0,
        setupOptType: '',
        setupOptOpt: '',
        setupOptDesc: '',
        setupOptAs400: '',
        setupOptGroup: '',
        setupOptStatus: '',
        setupOptSeq: 0,
        setupOptRgbRed: 0,
        setupOptRgbGreen: 0,
        setupOptRgbBlue: 0,
        setupOptColor: '',
        setupOptFabric: '',
        setupOptComment: '',
        setupOptUpdUser: '',
        setupOptUpdTs: '',
        setupOptYthSize: ''
    };


    const status: DropdownItem[] = useMemo(
        () => [
            { name: 'Active', code: 'A' },
            { name: 'Suspended', code: 'S' },
            { name: 'Deleted', code: 'D' }
        ],
        []
    );

    const [listValues, setListValues] = useState<SetupOpt[]>([]);
    const [listFilteredData, setListFilteredData] = useState<SetupOpt[]>([]);
    const [singleValue, setSingleValue] = useState<SetupOpt>(empty);
    const [listSetupTypes, setListSetupTypes] = useState<Code[]>([]);
    const [listSetupGroups, setListSetupGroups] = useState<Code[]>([]);
    const [loading, setLoading] = useState(true);
    const [globalFilter, setGlobalFilter] = useState<string>('');
    const [updateTrigger, setUpdateTrigger] = useState(0);
    const [setupOptionsColors, setSetupOptionsColors] = useState<SetupOptions[]>([]);
    const [fabrics, setFabrics] = useState<Fabric[]>([]);
    const [selectedSetupType, setSelectedSetupType] = useState('');

    const isNew = useRef(false);
    const form = useForm();
    const formEdit = useForm({ mode: "onChange" });
    const [editingRows, setEditingRows] = useState({});
    const errors = form.formState.errors;
    const toast = useRef<any>(null);
    const [deleteDialog, setDeleteDialog] = useState(false);
    const { accounts } = useMsal();
    const dt = useRef<any>(null);

    const [filters, setFilters] = useState<DataTableFilterMeta>(defaultFilters);
    const initFilters = () => {
        let _filters = { ...filters };

        // @ts-ignore
        _filters['global'].value = null;
        setFilters(defaultFilters);
        setGlobalFilter('');
    };

    useEffect(() => {
        MaintenanceService.getSetupOptions().then(data => {
            setListValues(data);
            setLoading(false);
        });

        SetupOptionsService.getSetupOptionsBaseColors().then(data => setSetupOptionsColors(data));
        MaintenanceService.getActiveFabrics().then(data => setFabrics(data));
        MaintenanceService.getSetupTypes().then(data => setListSetupTypes(data));
        MaintenanceService.getSetupGroups().then(data => setListSetupGroups(data));

        initFilters();
    }, []);

    useEffect(() => {
        MaintenanceService.getSetupOptions().then(data => {
            setListValues(data);
            setLoading(false);
        });
    }, [updateTrigger]);

    const exportCSV = () => {
        dt.current.exportCSV();
    };

    const getFilteredData = () => {
        const data = listFilteredData.length > 0 ? listFilteredData : dt.current.props.value;

        const bodyData = data.map((item: SetupOpt) => [
            item.setupOptId,
            item.setupOptType,
            item.setupOptOpt,
            item.setupOptDesc,
            item.setupOptAs400,
            item.setupOptGroup,
            item.setupOptSeq,
            item.setupOptStatus,
            item.setupOptColor,
            item.setupOptFabric,
            item.setupOptRgbRed,
            item.setupOptRgbGreen,
            item.setupOptYthSize,
            item.setupOptUpdTs,
            item.setupOptUpdUser
        ]);

        return bodyData;
    };

    const exportPdf = () => {
        const bodyData = getFilteredData();
        import('jspdf').then((jsPDF) => {
            import('jspdf-autotable').then(() => {
                const doc = new jsPDF.default("l");
                autoTable(doc, { head: [['Option Id', 'Option Type', 'Setup Option', 'Description', 'AS/400 Option', 'Sizing Group', 'Sizing Sequence', 'Status', 'Base Color', 'Fabric', 'Red', 'Green', 'Blue', 'Youth Size', 'Comment', 'Last Update Date', 'Last Update User']], body: bodyData })
                doc.save('setupoptions.pdf');
            });
        });
    };

    const onGlobalFilterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        let _filters = { ...filters };

        // @ts-ignore
        _filters['global'].value = value;

        setFilters(_filters);
        setGlobalFilter(value);
    };

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <div>
                <i className="pi pi-file-excel ml-3 text-green-500 cursor-pointer" title="Export CSV" onClick={(e) => { exportCSV(); e.stopPropagation(); }} />
                <i className="pi pi-file-pdf ml-3 text-red-500 cursor-pointer" title="Export PDF" onClick={(e) => { exportPdf(); e.stopPropagation(); }} />
            </div>
            <IconField iconPosition="left">
                <InputIcon className="pi pi-search" />
                <InputText className="p-inputtext-sm" type="search" autoComplete="off" value={globalFilter} onChange={onGlobalFilterChange} placeholder="Search..." />
            </IconField>
        </div>
    );

    const setupIdTemplate = (rowData: SetupOpt) => rowData.setupOptId;
    const setupTypeTemplate = (rowData: SetupOpt) => rowData.setupOptType;
    const setupOptionTemplate = (rowData: SetupOpt) => rowData.setupOptOpt;
    const setupDescriptionTemplate = (rowData: SetupOpt) => rowData.setupOptDesc;
    const setupAS400Template = (rowData: SetupOpt) => rowData.setupOptAs400;
    const setupGroupTemplate = (rowData: SetupOpt) => rowData.setupOptGroup;
    const setupStatusTemplate = (rowData: SetupOpt) => rowData.setupOptStatus;
    const setupSeqTemplate = (rowData: SetupOpt) => rowData.setupOptSeq;
    const setupRedTemplate = (rowData: SetupOpt) => rowData.setupOptRgbRed;
    const setupGreenTemplate = (rowData: SetupOpt) => rowData.setupOptRgbGreen;
    const setupBlueTemplate = (rowData: SetupOpt) => rowData.setupOptRgbBlue;
    const setupColorTemplate = (rowData: SetupOpt) => rowData.setupOptColor;
    const setupFabricTemplate = (rowData: SetupOpt) => rowData.setupOptFabric;
    const setupCommentTemplate = (rowData: SetupOpt) => rowData.setupOptComment;
    const setupUpduserTemplate = (rowData: SetupOpt) => rowData.setupOptUpdUser;
    const setupUpdtsTemplate = (rowData: SetupOpt) => rowData.setupOptUpdTs;
    const setupYthSizeTemplate = (rowData: SetupOpt) => {
        if (rowData.setupOptYthSize === 'Y') {
            return (
                <React.Fragment>
                    <i className="pi pi-check text-green-500"></i>
                </React.Fragment>
            );
        } else {
            return (
                <React.Fragment>
                    <i className="pi pi-times text-red-500"></i>
                </React.Fragment>
            );
        }
    }
    const clearNew = () => {
        form.reset();
        setSelectedSetupType('');
    }

    const getErrorMessage = (name: string) => {
        return errors[name] ? <small className="p-error">{(errors[name] as any).message}</small> : <small className="p-error">&nbsp;</small>;
    };

    const onSubmit = (data: any) => {
        isNew.current = true;
        let _value = { ...singleValue };
        _value.setupOptId = data.setupOptId;
        _value.setupOptType = data.setupOptType;
        _value.setupOptOpt = data.setupOptOpt;
        _value.setupOptDesc = data.setupOptDesc;
        _value.setupOptAs400 = data.setupOptAs400;
        _value.setupOptGroup = data.setupOptGroup ?? '';
        _value.setupOptStatus = data.setupOptStatus;
        _value.setupOptSeq = data.setupOptSeq;
        _value.setupOptRgbRed = data.setupOptRgbRed;
        _value.setupOptRgbGreen = data.setupOptRgbGreen;
        _value.setupOptRgbBlue = data.setupOptRgbBlue;
        _value.setupOptColor = data.setupOptColor ?? '';
        _value.setupOptFabric = data.setupOptFabric ?? '';
        _value.setupOptComment = data.setupOptComment;
        _value.setupOptYthSize = data.setupOptYthSize ? 'Y' : 'N';

        if (accounts[0]) {
            _value.setupOptUpdTs = new Date().toISOString();
            _value.setupOptUpdUser = accounts[0].username.split('@')[0];
        }

        save(_value);
        form.reset();
        setSelectedSetupType('');
    };

    const save = (value: SetupOpt) => {
        if (isNew.current) {
            MaintenanceService.addSetupOption(value).then(() => {
                setUpdateTrigger(prev => prev + 1);
                toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Setup Option Created', life: 3000 });
                setSingleValue(empty);
            }).catch(() => {
                toast.current.show({ severity: 'error', summary: 'Failed', detail: 'Failed to Create Setup Option', life: 3000 });
            });
        } else {
            MaintenanceService.updateSetupOption(value).then(() => {
                setUpdateTrigger(prev => prev + 1);
                toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Setup Option Updated', life: 3000 });
                setSingleValue(empty);
            }).catch(() => {
                toast.current.show({ severity: 'error', summary: 'Failed', detail: 'Failed to Update Setup Option', life: 3000 });
            });
        }
    }

    const setActiveRowIndexCE = (rowData: DataTableSelectionSingleChangeEvent<SetupOpt[]>) => {
        let selectedIndex = listValues.findIndex(v => v.setupOptId === (rowData.value as SetupOpt).setupOptId);
        let _editingRows = { ...editingRows, ...{ [`${listValues[selectedIndex].setupOptId}`]: true } };
        if (Object.keys(_editingRows).length === 1) {
            setEditingRows(_editingRows);
        }
    }

    const onRowEditChange = (e: any) => {
        setEditingRows(e.data);
    }

    const onRowEditComplete = (e: any) => {
        let _listValues = [...listValues];
        let { newData } = e;
        let index = listValues.findIndex(v => v.setupOptId === newData.setupOptId);
        _listValues[index] = newData;

        setListValues(_listValues);
    }

    const cellEditor = (options: ColumnEditorOptions) => {
        switch (options.field) {
            case 'setupOptOpt':
                return setupOptionEditor(options);

            case 'setupOptDesc':
                return setupDescriptionEditor(options);

            case 'setupOptAs400':
                return setupAS400Editor(options);

            case 'setupOptYthSize':
                return setupYthSizeEditor(options);

            case 'setupOptComment':
                return setupCommentEditor(options);

            case 'setupOptStatus':
                return setupStatusEditor(options);
        }
    }

    const setupDescriptionEditor = (options: any) => {
        return (
            <Controller
                name="setupOptDescEdit"
                control={formEdit.control}
                defaultValue={options.value}
                rules={{
                    required: 'Description is required.'
                }}
                render={({ field, fieldState }) => {
                    singleValue.setupOptDesc = field.value;

                    return (
                        <>
                            <InputText ref={field.ref} value={fieldState.isDirty ? field.value : options.value} maxLength={40} tooltip={fieldState.error?.message} tooltipOptions={{ position: 'bottom' }} className={classNames({ 'p-invalid border-left-10': fieldState.error })} onChange={(e) => { singleValue.setupOptDesc = e.target.value; field.onChange(e.target.value.toUpperCase()); }} placeholder="Description" />
                        </>
                    )
                }
                }
            />
        );
    }

    const setupOptionEditor = (options: any) => {
        return (
            <Controller
                name="setupOptOptEdit"
                control={formEdit.control}
                defaultValue={options.value}
                rules={{
                    required: 'Setup Option is required.'
                }}
                render={({ field, fieldState }) => {
                    singleValue.setupOptOpt = field.value;

                    return (
                        <>
                            <InputText
                                ref={field.ref}
                                value={fieldState.isDirty ? field.value : options.value}
                                maxLength={40}
                                tooltip={fieldState.error?.message}
                                tooltipOptions={{ position: 'bottom' }}
                                className={classNames({ 'p-invalid border-left-10': fieldState.error })}
                                onChange={(e) => {
                                    singleValue.setupOptOpt = e.target.value;
                                    field.onChange(e.target.value.toUpperCase());
                                }}
                                placeholder="Setup Option"
                            />
                        </>
                    );
                }}
            />
        );
    }

    const setupAS400Editor = (options: any) => {
        return (
            <Controller
                name="setupOptAs400Edit"
                control={formEdit.control}
                defaultValue={options.value}
                render={({ field, fieldState }) => {
                    singleValue.setupOptAs400 = field.value;

                    return (
                        <>
                            <InputText
                                ref={field.ref}
                                value={fieldState.isDirty ? field.value : options.value}
                                maxLength={40}
                                tooltip={fieldState.error?.message}
                                tooltipOptions={{ position: 'bottom' }}
                                className={classNames({ 'p-invalid border-left-10': fieldState.error })}
                                onChange={(e) => {
                                    singleValue.setupOptAs400 = e.target.value;
                                    field.onChange(e.target.value.toUpperCase());
                                }}
                                placeholder="AS400 Option"
                            />
                        </>
                    );
                }}
            />
        );
    }

    const setupYthSizeEditor = (options: any) => {
        return (
            <Controller
                name="setupOptYthSizeEdit"
                control={formEdit.control}
                defaultValue={options.value === 'Y'}
                render={({ field, fieldState }) => {
                    singleValue.setupOptYthSize = field.value ? 'Y' : 'N';
                    return (
                        <React.Fragment>
                            <Checkbox
                                inputId={field.name}
                                checked={fieldState.isDirty ? field.value : options.value === 'Y'}
                                inputRef={field.ref}
                                className={classNames('col-offset-0', { 'p-invalid mr-1': fieldState.error })}
                                onChange={(e) => {
                                    const checked = e.checked;
                                    singleValue.setupOptYthSize = checked ? 'Y' : 'N';
                                    field.onChange(checked);
                                }}
                            />
                        </React.Fragment>
                    );
                }}
            />
        );
    }

    const setupCommentEditor = (options: any) => {
        return (
            <Controller
                name="setupOptCommentEdit"
                control={formEdit.control}
                defaultValue={options.value}
                render={({ field, fieldState }) => {
                    singleValue.setupOptComment = field.value;

                    return (
                        <>
                            <InputText
                                ref={field.ref}
                                value={fieldState.isDirty ? field.value : options.value}
                                maxLength={225}
                                tooltip={fieldState.error?.message}
                                tooltipOptions={{ position: 'bottom' }}
                                className={classNames({ 'p-invalid border-left-10': fieldState.error })}
                                onChange={(e) => {
                                    singleValue.setupOptComment = e.target.value;
                                    field.onChange(e.target.value.toUpperCase());
                                }}
                                placeholder="Comment"
                            />
                        </>
                    );
                }}
            />
        );
    }

    const setupStatusEditor = (options: any) => {
        return (
            <Controller
                name="setupOptStatusEdit"
                control={formEdit.control}
                defaultValue={options.value}
                rules={{
                    required: 'Status is required.'
                }}
                render={({ field, fieldState }) => {
                    singleValue.setupOptStatus = field.value;

                    return (
                        <>
                            <Dropdown
                                inputId={field.name}
                                value={fieldState.isDirty ? field.value : options.value}
                                options={status}
                                optionLabel="name"
                                optionValue="code"
                                className={classNames('w-full', { 'p-invalid border-left-10': fieldState.error })}
                                onChange={(e) => {
                                    singleValue.setupOptStatus = e.value;
                                    field.onChange(e.value);
                                }}
                                placeholder="Select..."
                            />
                            {getErrorMessage('setupOptStatus')}
                        </>
                    );
                }}
            />
        );
    }

    const rowEditorTemplate = (rowData: SetupOpt, props: any) => {
        const rowEditor = props.rowEditor;
        if (rowEditor.editing) {
            isNew.current = false;

            return (
                <>
                    <Button icon="p-row-editor-save-icon pi pi-fw pi-save" title="Save" rounded text severity="info" type="submit" onClick={(e) => {
                        if (!formEdit.getFieldState("setupOptIdEdit").invalid && !formEdit.getFieldState("setupOptOptEdit").invalid && !formEdit.getFieldState("setupOptDescEdit").invalid) {
                            let _singleValue = { ...singleValue };

                            // next do not get updated so we set the previous value
                            _singleValue.setupOptId = rowData.setupOptId;
                            _singleValue.setupOptType = rowData.setupOptType;
                            _singleValue.setupOptGroup = rowData.setupOptGroup;
                            _singleValue.setupOptSeq = rowData.setupOptSeq;
                            _singleValue.setupOptColor = rowData.setupOptColor;
                            _singleValue.setupOptFabric = rowData.setupOptFabric;
                            _singleValue.setupOptRgbRed = rowData.setupOptRgbRed;
                            _singleValue.setupOptRgbGreen = rowData.setupOptRgbGreen;
                            _singleValue.setupOptRgbBlue = rowData.setupOptRgbBlue;


                            if (accounts[0]) {
                                _singleValue.setupOptUpdTs = new Date().toISOString();
                                _singleValue.setupOptUpdUser = accounts[0].username.split('@')[0];
                            }

                            save(_singleValue);
                            formEdit.reset();
                            rowEditor.onSaveClick(e);
                        }
                    }} />

                    <Button icon="p-row-editor-cancel-icon pi pi-fw pi-undo" title="Undo" rounded text severity="danger" onClick={(e) => {
                        formEdit.clearErrors();
                        formEdit.reset();
                        rowEditor.onCancelClick(e);
                    }} />
                </>
            );
        } else {
            return (
                <Link className="pi pi-fw pi-trash rowDelete" title="Delete" onClick={() => confirmDelete(rowData)} to={''}></Link>
            );
        }
    }

    const hideDeleteDialog = () => {
        setDeleteDialog(false);
    };

    const confirmDelete = (value: SetupOpt) => {
        setSingleValue(value);
        setDeleteDialog(true);
    }

    const deleteRow = () => {
        MaintenanceService.deleteSetupOption(singleValue.setupOptId).then((data: boolean) => {
            setUpdateTrigger(prev => prev + 1);
            setDeleteDialog(false);
            setSingleValue(empty);
            toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Deleted', life: 3000 });
        }).catch(() => {
            toast.current.show({ severity: 'error', summary: 'Failed', detail: 'Failed to remove', life: 3000 });
        });

    };

    const deleteDialogFooter = (
        <React.Fragment>
            <Button label="No" icon="pi pi-times" className="p-button-text" onClick={hideDeleteDialog} />
            <Button label="Yes" icon="pi pi-check" className="p-button-text" onClick={deleteRow} />
        </React.Fragment>
    );

    return (
        <>
            <Toast ref={toast} />

            <Panel header="Add Setup Option" className="addPanel mb-2 -ml-2">
                <form onSubmit={form.handleSubmit(onSubmit)} className="p-fluid" autoComplete="off">
                    <div className="formgrid grid">
                        <div className="field col-2">
                            <Controller
                                name="setupOptType"
                                control={form.control}
                                defaultValue=""
                                rules={{
                                    required: 'Setup Type is required.'
                                }}
                                render={({ field, fieldState }) => (
                                    <>
                                        <label htmlFor={field.name} className={classNames('font-bold text-xs', { 'p-error': errors.value })}>Setup Option Type</label>
                                        <Dropdown inputId={field.name} value={field.value} options={listSetupTypes} optionLabel="codeId" optionValue="codeId" className={classNames('w-full', { 'p-invalid border-left-10': fieldState.error })}
                                            onChange={(e) => { field.onChange(e.value); setSelectedSetupType(e.value) }} placeholder="Select..." />
                                        {getErrorMessage('setupOptType')}
                                    </>
                                )}
                            />
                        </div>
                        <div className="field col-2">
                            <Controller
                                name="setupOptOpt"
                                control={form.control}
                                defaultValue=""
                                rules={{
                                    required: 'Setup Option is required.'
                                }}
                                render={({ field, fieldState }) => (
                                    <>
                                        <label htmlFor={field.name} className="font-bold text-xs">Setup Option</label>
                                        <InputText id={field.name} name={field.name} value={field.value} maxLength={40} className={classNames({ 'p-invalid border-left-10': fieldState.error })} onChange={(e) => field.onChange(e.target.value.toUpperCase())} placeholder="Setup Option" />
                                        {getErrorMessage('setupOptOpt')}
                                    </>
                                )}
                            />
                        </div>
                        <div className="field col-2">
                            <Controller
                                name="setupOptDesc"
                                control={form.control}
                                defaultValue=""
                                rules={{
                                    required: 'Description is required.'
                                }}
                                render={({ field, fieldState }) => (
                                    <>
                                        <label htmlFor={field.name} className="font-bold text-xs">Description</label>
                                        <InputText id={field.name} name={field.name} value={field.value} maxLength={40} className={classNames({ 'p-invalid border-left-10': fieldState.error })} onChange={(e) => field.onChange(e.target.value.toUpperCase())} placeholder="Description" />
                                        {getErrorMessage('setupOptDesc')}
                                    </>
                                )}
                            />
                        </div>
                        <div className="field col-2">
                            <Controller
                                name="setupOptAs400"
                                control={form.control}
                                defaultValue=""
                                render={({ field, fieldState }) => (
                                    <>
                                        <label htmlFor={field.name} className="font-bold text-xs">AS400 Option</label>
                                        <InputText id={field.name} name={field.name} value={field.value} maxLength={40} className={classNames({ 'p-invalid border-left-10': fieldState.error })} onChange={(e) => field.onChange(e.target.value.toUpperCase())} placeholder="AS400 Option" />
                                        {getErrorMessage('setupOptAs400')}
                                    </>
                                )}
                            />
                        </div>
                        {['DET', 'MSC', 'SDT'].includes(selectedSetupType) && (
                            <div className="field col-2">
                                <Controller
                                    name="setupOptGroup"
                                    control={form.control}
                                    defaultValue=""
                                    render={({ field, fieldState }) => (
                                        <>
                                            <label htmlFor={field.name} className={classNames('font-bold text-xs', { 'p-error': errors.value })}>Setup Option Group</label>
                                            <Dropdown inputId={field.name} value={field.value} options={listSetupGroups} optionLabel="codeDesc" optionValue="codeId" className={classNames('w-full', { 'p-invalid border-left-10': fieldState.error })}
                                                onChange={(e) => { field.onChange(e.value) }} placeholder="Select..." virtualScrollerOptions={{ itemSize: 50 }} filter
                                                filterBy="setupOption" />
                                            {getErrorMessage('setupOptGroup')}
                                        </>
                                    )}
                                />
                            </div>
                        )}
                        {selectedSetupType === 'SIZ' && (
                            <div className="field col-2">
                                <Controller
                                    name="setupOptGroup"
                                    control={form.control}
                                    defaultValue=""
                                    rules={{
                                        required: 'Sizing Group is required.'
                                    }}
                                    render={({ field, fieldState }) => (
                                        <>
                                            <label htmlFor={field.name} className="font-bold text-xs">Sizing Group</label>
                                            <InputText id={field.name} name={field.name} value={field.value} maxLength={40} className={classNames({ 'p-invalid border-left-10': fieldState.error })} onChange={(e) => field.onChange(e.target.value.toUpperCase())} placeholder="Sizing Group" />
                                            {getErrorMessage('setupOptGroup')}
                                        </>
                                    )}
                                />
                            </div>
                        )}
                        {selectedSetupType === 'SIZ' && (
                            <div className="field col-2">
                                <Controller
                                    name="setupOptSeq"
                                    control={form.control}
                                    defaultValue=""
                                    rules={{
                                        required: 'Sizing Sequence is required.',
                                        validate: {
                                            maxDigits: value => (value && value.toString().length <= 10) || 'Sizing Sequence must not have more than 10 digits.'
                                        }
                                    }}
                                    render={({ field, fieldState }) => (
                                        <>
                                            <label htmlFor={field.name} className="font-bold text-xs">Sizing Sequence</label>
                                            <InputNumber id={field.name} name={field.name} value={field.value} useGrouping={false} className={classNames({ 'p-invalid border-left-10': fieldState.error })} onChange={(e) => field.onChange(e.value)} placeholder="Size" />
                                            {getErrorMessage('setupOptSeq')}
                                        </>
                                    )}
                                />
                            </div>
                        )}
                        <div className="field col-fixed isCheckbox">
                            <Controller
                                name="setupOptYthSize"
                                control={form.control}
                                render={({ field, fieldState }) => (
                                    <React.Fragment>
                                        <label htmlFor={field.name} className="font-bold text-xs">Youth Sizing</label><br />
                                        <Checkbox inputId={field.name} checked={field.value} inputRef={field.ref} className={classNames('col-offset-4', { 'p-invalid mr-1': fieldState.error })} onChange={(e) => field.onChange(e.checked)} />
                                    </React.Fragment>
                                )}
                            />
                        </div>
                        <div className="field col-2">
                            <Controller
                                name="setupOptComment"
                                control={form.control}
                                defaultValue=""
                                render={({ field, fieldState }) => (
                                    <>
                                        <label htmlFor={field.name} className="font-bold text-xs">Comment</label>
                                        <InputText id={field.name} name={field.name} value={field.value} maxLength={225} className={classNames({ 'p-invalid border-left-10': fieldState.error })} onChange={(e) => field.onChange(e.target.value.toUpperCase())} placeholder="Comment" />
                                        {getErrorMessage('setupOptComment')}
                                    </>
                                )}
                            />
                        </div>
                        <div className="field col-2">
                            <Controller
                                name="setupOptStatus"
                                control={form.control}
                                defaultValue={'A'}
                                rules={{
                                    required: 'Status is required.'
                                }}
                                render={({ field, fieldState }) => (
                                    <>
                                        <label htmlFor={field.name} className={classNames('font-bold text-xs', { 'p-error': errors.value })}>Setup Status</label>
                                        <Dropdown inputId={field.name} value={field.value} options={status} optionLabel="name" optionValue="code" className={classNames('w-full', { 'p-invalid border-left-10': fieldState.error })}
                                            onChange={(e) => { field.onChange(e.value) }} placeholder="Select..." />
                                        {getErrorMessage('setupOptStatus')}
                                    </>
                                )}
                            />
                        </div>
                        {selectedSetupType === 'CLR' && (
                            <div className="field col-2">
                                <Controller
                                    name="setupOptColor"
                                    control={form.control}
                                    defaultValue=""
                                    rules={{
                                        required: 'Base color is required.'
                                    }}
                                    render={({ field, fieldState }) => (
                                        <>
                                            <label htmlFor={field.name} className={classNames('font-bold text-xs', { 'p-error': errors.value })}>Base Color</label>
                                            <Dropdown inputId={field.name} value={field.value} options={setupOptionsColors} optionLabel="setupOption" optionValue="setupOption" className={classNames('w-full', { 'p-invalid border-left-10': fieldState.error })}
                                                onChange={(e) => { field.onChange(e.value) }} placeholder="Select..." virtualScrollerOptions={{ itemSize: 50 }} filter
                                                filterBy="setupOption" />
                                            {getErrorMessage('setupOptColor')}
                                        </>
                                    )}
                                />
                            </div>
                        )}
                        {selectedSetupType === 'CLR' && (
                            <div className="field col-2">
                                <Controller
                                    name="setupOptFabric"
                                    control={form.control}
                                    defaultValue=""
                                    rules={{
                                        required: 'Fabric is required.'
                                    }}
                                    render={({ field, fieldState }) => (
                                        <>
                                            <label htmlFor={field.name} className={classNames('font-bold text-xs', { 'p-error': errors.value })}>Fabric</label>
                                            <Dropdown inputId={field.name} value={field.value} options={fabrics} optionLabel="fabricCd" optionValue="fabricCd" className={classNames('w-full', { 'p-invalid border-left-10': fieldState.error })}
                                                onChange={(e) => { field.onChange(e.value) }} placeholder="Select..." virtualScrollerOptions={{ itemSize: 50 }} filter
                                                filterBy="fabricCd" />
                                            {getErrorMessage('setupOptFabric')}
                                        </>
                                    )}
                                />
                            </div>
                        )}
                        {selectedSetupType === 'CLR' && (
                            <div className="field col-1">
                                <Controller
                                    name="setupOptRgbRed"
                                    control={form.control}
                                    defaultValue={null}
                                    rules={{
                                        validate: {
                                            range: value => (value === null || (value >= 0 && value <= 255)) || 'Red must be between 0 and 255.'
                                        }
                                    }}
                                    render={({ field, fieldState }) => (
                                        <>
                                            <label htmlFor={field.name} className="font-bold text-xs">Red</label>
                                            <InputNumber id={field.name} name={field.name} value={field.value} useGrouping={false} className={classNames('w-full', { 'p-invalid border-left-10': fieldState.error })} onChange={(e) => field.onChange(e.value)} placeholder="Red" />
                                            {getErrorMessage('setupOptRgbRed')}
                                        </>
                                    )}
                                />
                            </div>
                        )}
                        {selectedSetupType === 'CLR' && (
                            <div className="field col-1">
                                <Controller
                                    name="setupOptRgbGreen"
                                    control={form.control}
                                    defaultValue={null}
                                    rules={{
                                        validate: {
                                            range: value => (value === null || (value >= 0 && value <= 255)) || 'Red must be between 0 and 255.'
                                        }
                                    }}
                                    render={({ field, fieldState }) => (
                                        <>
                                            <label htmlFor={field.name} className="font-bold text-xs">Green</label>
                                            <InputNumber id={field.name} name={field.name} value={field.value} useGrouping={false} className={classNames('w-full', { 'p-invalid border-left-10': fieldState.error })} onChange={(e) => field.onChange(e.value)} placeholder="Green" />
                                            {getErrorMessage('setupOptRgbGreen')}
                                        </>
                                    )}
                                />
                            </div>
                        )}
                        {selectedSetupType === 'CLR' && (
                            <div className="field col-1">
                                <Controller
                                    name="setupOptRgbBlue"
                                    control={form.control}
                                    defaultValue={null}
                                    rules={{
                                        validate: {
                                            range: value => (value === null || (value >= 0 && value <= 255)) || 'Red must be between 0 and 255.'
                                        }
                                    }}
                                    render={({ field, fieldState }) => (
                                        <>
                                            <label htmlFor={field.name} className="font-bold text-xs">Blue</label>
                                            <InputNumber id={field.name} name={field.name} value={field.value} useGrouping={false} className={classNames('w-full', { 'p-invalid border-left-10': fieldState.error })} onChange={(e) => field.onChange(e.value)} placeholder="Blue" />
                                            {getErrorMessage('setupOptRgbBlue')}
                                        </>
                                    )}
                                />
                            </div>
                        )}
                        <div className="field field-buttons col-2 pt-4">
                            <Button icon="pi pi-save" title="Save" rounded text severity="info" type="submit" />
                            <Button icon="pi pi-undo" title="Undo" rounded text severity="danger" type="button" onClick={clearNew} />
                        </div>
                    </div>
                </form>
            </Panel>

            <DataTable ref={dt} className="-ml-2" value={listValues} selectionMode="single" onSelectionChange={setActiveRowIndexCE}
                dataKey="setupOptId" size="small" rowHover={true} loading={loading}
                scrollable scrollHeight="calc(100vh - 23.9rem)"
                paginator rows={25} rowsPerPageOptions={[5, 10, 25]} alwaysShowPaginator={false}
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                editingRows={editingRows} editMode="row" onRowEditChange={onRowEditChange} onRowEditComplete={onRowEditComplete}
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} records"
                filters={filters} onValueChange={filteredData => setListFilteredData(filteredData)}
                emptyMessage="No setup options records found." header={header}>
                <Column field="setupOptId" header="Option Id" sortable body={setupIdTemplate} filter filterPlaceholder="Search..." align="center" alignHeader="center" headerStyle={{ width: '10%', minWidth: '10rem' }}></Column>
                <Column field="setupOptType" header="Option Type" sortable body={setupTypeTemplate} filter filterPlaceholder="Search..." align="center" alignHeader="center" headerStyle={{ width: '10%', minWidth: '10rem' }}></Column>
                <Column field="setupOptOpt" header="Setup Option" sortable body={setupOptionTemplate} filter filterPlaceholder="Search..." editor={(options: ColumnEditorOptions) => cellEditor(options)} align="center" alignHeader="center" headerStyle={{ width: '10%', minWidth: '10rem' }}></Column>
                <Column field="setupOptDesc" header="Description" sortable body={setupDescriptionTemplate} filter filterPlaceholder="Search..." editor={(options: ColumnEditorOptions) => cellEditor(options)} align="center" alignHeader="center" headerStyle={{ width: '10%', minWidth: '10rem' }}></Column>
                <Column field="setupOptAs400" header="AS/400 Option" sortable body={setupAS400Template} filter filterPlaceholder="Search..." editor={(options: ColumnEditorOptions) => cellEditor(options)} align="center" alignHeader="center" headerStyle={{ width: '10%', minWidth: '10rem' }}></Column>
                <Column field="setupOptGroup" header="Sizing Group" sortable body={setupGroupTemplate} filter filterPlaceholder="Search..." align="center" alignHeader="center" headerStyle={{ width: '10%', minWidth: '10rem' }}></Column>
                <Column field="setupOptSeq" header="Sizing Sequence" sortable body={setupSeqTemplate} filter filterPlaceholder="Search..." align="center" alignHeader="center" headerStyle={{ width: '10%', minWidth: '10rem' }}></Column>
                <Column field="setupOptStatus" header="Status" sortable body={setupStatusTemplate} filter filterPlaceholder="Search..." editor={(options: ColumnEditorOptions) => cellEditor(options)} align="center" alignHeader="center" headerStyle={{ width: '10%', minWidth: '10rem' }}></Column>
                <Column field="setupOptColor" header="Base Color" sortable body={setupColorTemplate} filter filterPlaceholder="Search..." align="center" alignHeader="center" headerStyle={{ width: '10%', minWidth: '10rem' }}></Column>
                <Column field="setupOptFabric" header="Fabric" sortable body={setupFabricTemplate} filter filterPlaceholder="Search..." align="center" alignHeader="center" headerStyle={{ width: '10%', minWidth: '10rem' }}></Column>
                <Column field="setupOptRgbRed" header="Red" sortable body={setupRedTemplate} filter filterPlaceholder="Search..." align="center" alignHeader="center" headerStyle={{ width: '10%', minWidth: '10rem' }}></Column>
                <Column field="setupOptRgbGreen" header="Green" sortable body={setupGreenTemplate} filter filterPlaceholder="Search..." align="center" alignHeader="center" headerStyle={{ width: '10%', minWidth: '10rem' }}></Column>
                <Column field="setupOptRgbBlue" header="Blue" sortable body={setupBlueTemplate} filter filterPlaceholder="Search..." align="center" alignHeader="center" headerStyle={{ width: '10%', minWidth: '10rem' }}></Column>
                <Column field="setupOptYthSize" header="Youth Size" sortable body={setupYthSizeTemplate} filter filterPlaceholder="Search..." editor={(options: ColumnEditorOptions) => cellEditor(options)} align="center" alignHeader="center" headerStyle={{ width: '10%', minWidth: '10rem' }}></Column>
                <Column field="setupOptComment" header="Comment" sortable body={setupCommentTemplate} filter filterPlaceholder="Search..." editor={(options: ColumnEditorOptions) => cellEditor(options)} align="center" alignHeader="center" headerStyle={{ width: '10%', minWidth: '10rem' }}></Column>
                <Column field="setupOptUpdTs" header="Last Update Date" sortable body={setupUpdtsTemplate} filter filterPlaceholder="Search..." align="center" alignHeader="center" headerStyle={{ width: '10%', minWidth: '10rem' }}></Column>
                <Column field="setupOptUpdUser" header="Last Update User" sortable body={setupUpduserTemplate} filter filterPlaceholder="Search..." align="center" alignHeader="center" headerStyle={{ width: '10%', minWidth: '10rem' }}></Column>
                <Column rowEditor body={rowEditorTemplate} headerStyle={{ width: '10%', minWidth: '8rem' }} bodyStyle={{ textAlign: 'center' }}></Column>
            </DataTable>

            <Dialog visible={deleteDialog} style={{ width: '32rem' }} breakpoints={{ '960px': '75vw', '641px': '90vw' }} header="Confirm" modal footer={deleteDialogFooter} onHide={hideDeleteDialog}>
                <div className="confirmation-content">
                    <i className="pi pi-exclamation-triangle mr-3" style={{ fontSize: '2rem' }} />
                    {singleValue && (
                        <span>
                            Are you sure you want to delete <b>{singleValue.setupOptId}</b>?
                        </span>
                    )}
                </div>
            </Dialog>
        </>
    )
}